export var radiusPrimitives = {
  none: '0px',
  xs: '2px',
  s: '4px',
  m: '8px',
  l: '12px',
  xl: '16px',
  xxl: '24px',
  round: '100%'
};
export var radiusTokens = {
  component: {
    dialog: radiusPrimitives.xxl,
    card: radiusPrimitives.xl,
    container: {
      main: radiusPrimitives.xl,
      nested1: radiusPrimitives.l,
      nested2: radiusPrimitives.m
    },
    banner: {
      main: radiusPrimitives.xl,
      nested: radiusPrimitives.l
    },
    snackBar: radiusPrimitives.l,
    inputField: radiusPrimitives.m,
    button: radiusPrimitives.m,
    tag: radiusPrimitives.s
  },
  generic: {
    none: radiusPrimitives.none,
    minimal: radiusPrimitives.xs,
    small: radiusPrimitives.s,
    medium: radiusPrimitives.m,
    large: radiusPrimitives.xl,
    xxxLarge: radiusPrimitives.xxl,
    full: radiusPrimitives.round
  }
};